import { render, staticRenderFns } from "./NavigationMore.vue?vue&type=template&id=155c7d0a&scoped=true&"
import script from "./NavigationMore.vue?vue&type=script&lang=ts&"
export * from "./NavigationMore.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationMore.vue?vue&type=style&index=0&id=155c7d0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c7d0a",
  null
  
)

export default component.exports